// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/_to-object.js
// module id = 50
// module chunks = 0